import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stockoutRequestSO: null,
  loading: false,
  error: null,
};

const stockoutRequestSOSlice = createSlice({
  name: "stockoutRequestSO",
  initialState,
  reducers: {
    fetchStockoutRequestSOStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchStockoutRequestSOSuccess: (state, action) => {
      state.loading = false;
      state.stockoutRequestSO = action.payload;
      state.error = null;
    },

    fetchStockoutRequestSOFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchStockoutRequestSOStart,
  fetchStockoutRequestSOSuccess,
  fetchStockoutRequestSOFailure,
} = stockoutRequestSOSlice.actions;

export default stockoutRequestSOSlice.reducer;